module.exports = __webpack_public_path__ + "static/img/default_thumbnail.df41f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default_thumbnail.jpg
// module id = pB3D
// module chunks = 0